import { defaultState } from './defaultState';
import type { CasinoGameDeckState } from './types';

export const reducers = {
  clear: (): CasinoGameDeckState => defaultState,
  set: (state: CasinoGameDeckState, payload: CasinoGameDeckState) => payload,
  setLoading: (state: CasinoGameDeckState, payload: boolean) => ({ ...state, loading: payload })
};
